"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ProgressBar_1 = __importDefault(require("react-bootstrap/ProgressBar"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
require("./progress.scss");
function Progress(props) {
    var now = props.value || 0;
    var percent = "".concat(Math.round(now), "%");
    var label = props.label || percent;
    var bgWidth = "".concat(100 - now, "%");
    var selectProps = __assign({}, props);
    var barLabel = "progress-label me-1 align-self-end";
    var getLabel = function (classes) { return react_1.default.createElement("div", { className: "".concat(classes, " visually-hidden") }, label); };
    delete selectProps.bgClassName;
    return (react_1.default.createElement(ProgressBar_1.default, { className: (0, classMap_1.default)("mpng-ux-progress", props.className) },
        react_1.default.createElement(ProgressBar_1.default, __assign({}, selectProps, { now: now !== null && now !== void 0 ? now : 0,
            className: "bar",
            label: getLabel(barLabel),
            "aria-label": label,
            "aria-hidden": false,
            role: "progressbar" })),
        react_1.default.createElement(ProgressBar_1.default, { style: { width: bgWidth }, className: "bar-bg d-flex flex-column justify-content-center ".concat(props.bgClassName), label: getLabel(barLabel), "aria-hidden": "true", role: "presentation" })));
}
exports.default = Progress;
